export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/point.js
// module id = a0Ay
// module chunks = 0